// import { useNavigate } from "react-router-dom";
import { Button, Form, Input, Card } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { showSuccessToast, showErrorToast } from "../ToastHelper";
import { changePasswordService } from "../services/adminService";
import { AuthTokenContext, userDataContext } from "../context/tokenContext";
import { useContext, useState } from "react";
function ChangePassword() {
  const [token, setToken] = useContext(AuthTokenContext);
  const [userData, setUserData] = useContext(userDataContext);
  const [loading,setLoading]=useState(false);

  const [form] = Form.useForm();
  // const navigate = useNavigate();
  async function ChangePassword(values) {
    try {
      setLoading(true)
      values.email = userData.userEmail;
      let response = await changePasswordService(values, token);
      setLoading(false)
      if (response.statusCode === 0 && response.statusMsg === "Success") {
        setUserData({ userStatus: "ACT" });
        showSuccessToast("Password Changed Successfully");
      }
    } catch (error) {
      setLoading(false)

      showErrorToast(error.message);
    }
  }
  return (
    <Card
      style={{
        marginTop: "10px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
      }}
      bordered={false}
    >
      <Form
        form={form}
        name="basic"
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 16 }}
        style={{ marginTop: "2.5rem" }}
        initialValues={{ remember: true }}
        onFinish={ChangePassword}
        autoComplete="off"
      >
        <Form.Item
          label="Current Password"
          name="currentPassword"
          rules={[{ required: true, message: "Please input your Password!" }]}
        >
          <Input.Password
            prefix={<LockOutlined className="site-form-item-icon" />}
            placeholder="Current Password"
          />
        </Form.Item>
        <Form.Item
          label="New Password"
          name="newPassword"
          rules={[{ required: true, message: "Please input your Password!" }]}
        >
          <Input.Password
            prefix={<LockOutlined className="site-form-item-icon" />}
            placeholder="New Password"
          />
        </Form.Item>
        <Form.Item
          label="Confirm Password"
          name="confirmPassword"
          rules={[{ required: true, message: "Please input your Password!" }]}
        >
          <Input.Password
            size="medium"
            prefix={<LockOutlined className="site-form-item-icon" />}
            placeholder="Confirm New Password"
          />
        </Form.Item>
        <Form.Item style={{ float: "right" }}>
          <Button type="primary" htmlType="submit" loading={loading}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
}

export default ChangePassword;
